export class JiraCredential {
    username: string;
    apiKey: string;
    tempoKey: string;
}
